export default {
  "HitPaw Online Audio Joiner": "HitPaw Online Audio Joiner",
  "Merge Audio": "Juntar Áudio",
  "Merge multiple audio tracks into one.": "Juntar várias faixas de áudio em uma só",
  "Merge New": "Juntar Novo",
  "Merge failed": "Falha em Juntar",
  "Fade in": "Fade-in",
  "Fade out": "Fade-out",
  "Add tracks": "Adicionar faixas",
  "Format": "Formato",
};
